module.exports = __webpack_public_path__ + "img/banner-two2.74722488.png";